import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./Field";
import { cn } from "../../lib/utils";

type Props = React.InputHTMLAttributes<HTMLInputElement> & { testId?: string };

export function PasswordInput({ testId, className, ...rest }: Props) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input {...rest} type={show ? "text" : "password"} className={cn("pr-10", className)} data-testid={testId} />
      <button type="button" tabIndex={-1} onClick={() => setShow(!show)} aria-label={show ? "Hide password" : "Show password"} title={show ? "Hide password" : "Show password"} className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-1 text-slate-400 hover:text-slate-700" data-testid={testId ? `${testId}-toggle` : undefined}>
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
